export default "__VITE_ASSET__CMTJZ3X3__"